import { Typography } from "@mui/material";
import EditSection from "components/common/ui/EditSection";
import CommonButton from "components/common/ui/CommonButton";
import { FC, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "hooks/useReduxStore";
import { menusInWeekActions } from "store/slices/menu/menusInWeekSlice";
import currentSiteSelector from "store/selectors/userGroup/currentSiteSelector";
import dayjs from "dayjs";

interface ChooseDateRangeOrALaCarteStepProps {
  handleNext: (increment?: number) => () => void;
}

const ChooseDateRangeOrALaCarteStep: FC<ChooseDateRangeOrALaCarteStepProps> = ({
  handleNext,
}) => {
  const dispatch = useAppDispatch();
  const currentSiteId = useAppSelector(currentSiteSelector.currentSiteId);

  const handleALaCarte = useCallback((): void => {
    dispatch(menusInWeekActions.updateMenuType("alternate menu"));
    dispatch(
      menusInWeekActions.fetchMenusInWeek({
        startDate: dayjs(),
        endDate: dayjs(),
        menuType: "alternate menu",
        forSiteId: currentSiteId,
      }),
    );
    handleNext(2)();
  }, [currentSiteId, dispatch, handleNext]);

  const handleChooseDateRange = useCallback((): void => {
    dispatch(menusInWeekActions.updateMenuType("cycling menu"));
    handleNext(1)();
  }, [dispatch, handleNext]);

  return (
    <>
      <Typography>
        Do you want to get ingredient purchase list for daily menus or
        a-la-carte menu?
      </Typography>
      <EditSection>
        <CommonButton
          text="Choose Date Range"
          onClick={handleChooseDateRange}
          positive
        />
        <CommonButton text="A-la-carte" onClick={handleALaCarte} positive />
      </EditSection>
    </>
  );
};

export default ChooseDateRangeOrALaCarteStep;
